//
//
//
//
//
//

import MoominContent from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominContent/MoominContent.vue";
export default {
  name: "MoominRichTextContent",
  components: {
    MoominContent,
  },
  props: {
    content: {
      type: Object,
      default: "",
    }
  }
};
